import { createI18n } from 'vue-i18n';
import genericEn from '@/plugins/localisation/translations/generic/en.json';
import dateTimeFormats from '@/plugins/localisation/dateTimeFormats.json';
import { config, getTranslations } from '@/services/config';

export const translationsState = {
  // Note: English will always be used for generic translations
  // if there is an api connection error when loading the app
  locale: 'en',
  fallbackLocale: 'en',
  dateTimeFormats,
};

export const genericTranslations = createI18n({
  globalInjection: true,
  legacy: false,
  locale: translationsState.locale,
  fallbackLocale: translationsState.fallbackLocale,
  datetimeFormats: translationsState.dateTimeFormats,
  messages: { en: genericEn },
  missing(locale: string, key: string) {
    console.error(`Translation Missing:${locale}:${key}`); // eslint-disable-line no-console
    return `${key}`;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export let translations: any = {};

export const populateTranslations = () => {
  const en = getTranslations();

  if (
    config.layout &&
    config.layout.options &&
    config.layout.options.defaultLanguage
  ) {
    translationsState.locale = config.layout.options.defaultLanguage;
  }

  translations = createI18n({
    globalInjection: true,
    legacy: false,
    locale: translationsState.locale,
    fallbackLocale: translationsState.fallbackLocale,
    datetimeFormats: translationsState.dateTimeFormats,
    messages: { en },
    missing(locale: string, key: string) {
      console.error(`Translation Missing:${locale}:${key}`); // eslint-disable-line no-console
      return `${key}`;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any);
};
